// extracted by mini-css-extract-plugin
export var ModalFlyout = "ModalFlyout-module--ModalFlyout--vUr3u";
export var ModalFlyoutAnimateClose = "ModalFlyout-module--ModalFlyoutAnimateClose--pJVEu";
export var ModalFlyoutAnimateOpen = "ModalFlyout-module--ModalFlyoutAnimateOpen--dCfDs";
export var ModalFlyoutCloseButton = "ModalFlyout-module--ModalFlyoutCloseButton--k5Kk+";
export var slideIn = "ModalFlyout-module--slide-in--d5oyb";
export var slideOut = "ModalFlyout-module--slide-out--YU9Zb";